const KLAVIYO_SCRIPT = '//www.klaviyo.com/media/js/public/klaviyo_subscribe.js';
const JQUERY_SCRIPT = 'https://code.jquery.com/jquery-3.7.1.min.js';

let klaviyoReadyPromise = null;

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      if (existing.dataset.loaded === 'true') return resolve();
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', reject);
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.addEventListener('load', () => {
      script.dataset.loaded = 'true';
      resolve();
    });
    script.addEventListener('error', reject);
    document.head.appendChild(script);
  });
}

function ensureKlaviyo() {
  if (klaviyoReadyPromise) return klaviyoReadyPromise;
  klaviyoReadyPromise = (async () => {
    if (!window.jQuery) await loadScript(JQUERY_SCRIPT);
    if (!window.KlaviyoSubscribe) await loadScript(KLAVIYO_SCRIPT);
  })();
  return klaviyoReadyPromise;
}

class NewsletterOverlapForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.successEl = this.querySelector('.newsletter-form__message--success');
    this.errorEl = this.querySelector('.newsletter-form__message--error');
    this.errorTextEl = this.querySelector('[data-error-text]');
    this.submitBtn = this.querySelector('button[type="submit"]');

    if (!this.form) return;
    if (!this.dataset.listId) {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.showError('Newsletter list not configured.');
      });
      return;
    }

    ensureKlaviyo()
      .then(() => this.attach())
      .catch(() => {
        this.form.addEventListener('submit', () => this.setLoading(true));
      });
  }

  attach() {
    const formId = this.form.id;
    if (!formId || !window.KlaviyoSubscribe) return;

    window.KlaviyoSubscribe.attachToForms('#' + formId, {
      custom_success_message: true,
      hide_form_on_success: false,
      extra_properties: { $source: 'Newsletter footer' },
    });

    this.form.addEventListener('submit', () => {
      this.hideMessages();
      this.setLoading(true);
    });

    const $form = window.jQuery(this.form);
    $form.on('klaviyo.subscribe.success', () => {
      this.setLoading(false);
      this.showSuccess();
      this.form.reset();
    });
    $form.on('klaviyo.subscribe.error', (_e, errors) => {
      this.setLoading(false);
      const msg = (Array.isArray(errors) && errors[0]) || 'Could not subscribe. Try again.';
      this.showError(msg);
    });
  }

  setLoading(loading) {
    if (!this.submitBtn) return;
    this.submitBtn.disabled = loading;
    this.submitBtn.toggleAttribute('aria-busy', loading);
  }

  hideMessages() {
    this.successEl?.setAttribute('hidden', '');
    this.errorEl?.setAttribute('hidden', '');
  }

  showSuccess() {
    this.successEl?.removeAttribute('hidden');
  }

  showError(message) {
    if (!this.errorEl) return;
    if (this.errorTextEl) this.errorTextEl.textContent = message;
    this.errorEl.removeAttribute('hidden');
  }
}

customElements.define('newsletter-overlap-form', NewsletterOverlapForm);
